import Vue from 'vue'
import App from './App'

import iView from 'iview';
import 'iview/dist/styles/iview.css';

import store from './components/store'

import VueHighcharts from 'vue-highcharts';
import Highcharts from 'highcharts';
import loadExporting from 'highcharts/modules/exporting';
import loadOffExporting from 'highcharts/modules/offline-exporting';
import loadDataExport from 'highcharts/modules/export-data';

loadExporting(Highcharts);
loadOffExporting(Highcharts);
loadDataExport(Highcharts);

Vue.use(VueHighcharts, { Highcharts });

Vue.config.productionTip = false;
Vue.use(iView);

new Vue({
  el: '#app',
  store,
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js